import BusinessFaq from "components/business/businessFaq";
import BusinessGrid from "components/business/businessGrid";
import BusinessOne from "components/business/businessOne";
import BusinessSteps from "components/business/businessSteps";
import BusinessCta from "components/business/businessCta";
import Hero from "components/business/hero";
import Head from "next/head";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Features = () => {
  return (
    <>
      <Head>
        <title>Social Media Content Management Software for Business</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Looking for an automated way to audit, monitor, and manage your company's social media accounts? Mange your company's online risk, across all platforms. Learn more about redact for business."
        />
        <meta name="keywords" content="redact mass delete privacy free features" />

        <meta property="og:title" content="Social Media Content Management Software for Business" />
        <meta
          property="og:description"
          content="Looking for an automated way to audit, monitor, and manage your company's social media accounts? Mange your company's online risk, across all platforms. Learn more about redact for business."
        />

        <meta property="og:url" content="https://www.redact.dev/business" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <Hero />
        <BusinessOne />
        <BusinessGrid />
        <BusinessSteps />
        <BusinessFaq />
        <BusinessCta />
      </StyledWrapper>
    </>
  );
};

export default Features;
